/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-report-translation-list-page',
  template: `
    <ng-template #rowTemplate let-item>
      <td><a [uiSref]="itemStateName" [uiParams]="{id: item.id}">{{ item.name }}</a></td>
      <td>{{ item.description }}</td>
      <td>{{ ('locale.' + item.locale) | ogTranslate }}</td>
      <td>{{ ('language.' + item.defaultTranslation) | ogTranslate }}</td>
    </ng-template>
    <adn-admin-resource-list-shell
      [page]="this"
      [columns]="columns"
      emptyMessage="No report translations are available."
      [rowTemplate]="rowTemplate">
      <adn-search-list listToolbar [list]="list"></adn-search-list>
    </adn-admin-resource-list-shell>
  `
})
export class ReportTranslationListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.rep.report-translations.report-translation';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'locale'},
    {param: 'defaultTranslation'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }

}
